var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const sherbertAPI = 'https://api.sherbert.cimpress.io/v2';
function getFolderId({ shopperId, tenant, authToken, }) {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield fetch(`${sherbertAPI}/folders?folderName=${shopperId}&scopeToUserFolders=true&tenant=${tenant}`, {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${authToken}`,
            },
        });
        const responseJson = yield response.json();
        return (_c = (_b = (_a = responseJson._embedded) === null || _a === void 0 ? void 0 : _a.item) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.id;
    });
}
function createFolder({ shopperId, tenant, authToken, }) {
    return __awaiter(this, void 0, void 0, function* () {
        const createFolderBody = {
            tenant,
            // the assets sdk doesn't appear to provide any properties
            properties: {},
            name: shopperId,
            info: {
                asset: {
                    folder: {
                        isUserFolder: true,
                    },
                },
            },
        };
        const response = yield fetch(`${sherbertAPI}/folders`, {
            method: 'POST',
            body: JSON.stringify(createFolderBody),
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${authToken}`,
            },
        });
        const folder = yield response.json();
        return folder.id;
    });
}
export function fetchFolderIdForShopper({ shopperId, tenant, authToken, }) {
    return __awaiter(this, void 0, void 0, function* () {
        const folderId = yield getFolderId({ shopperId, tenant, authToken });
        if (!folderId || folderId.length === 0) {
            return createFolder({ shopperId, tenant, authToken });
        }
        return folderId;
    });
}
//# sourceMappingURL=folderUtilities.js.map